import { useRef } from 'react';

const useLocal = <T>(initialValueCreator: () => T): T => {
  const ref = useRef<{ value: T } | null>(null);

  if (!ref.current) {
    ref.current = { value: initialValueCreator() };
  }

  return ref.current.value;
};

export default useLocal;
